export default Form => props => <Form noHtml5Validate {...props} />;
